// Single case set for the Clue Sorting Game
export const caseData = [
  {
    id: 1,
    title: "Case 1: The Maestro's Muted Melody",
    description: "At the grand opening of the city's new concert hall, a priceless Stradivarius violin, intended for the evening's star performer, vanishes moments before the curtain rises. The show must go on, but a shadow of suspicion falls over the orchestra.",
    difficulty: "medium",
    clues: [
      { id: 8, text: "The velvet lining of an expensive instrument container shows a slight tear near the latch.", belongsTo: 1 },
      { id: 3, text: "One elegant glove, ladies' size, was found discarded by a rarely used exit.", belongsTo: 1 },
      { id: 10, text: "An uncommon amount of rosin dust coated a nearby musician's chair, more than typical pre-performance.", belongsTo: 1 }
    ]
  },
  {
    id: 2,
    title: "Case 2: The Silent Watchtower's Secret",
    description: "In a remote coastal lighthouse, the seasoned keeper has disappeared without a trace, leaving behind only an eerie calm and a half-finished logbook entry. Was it an accident, foul play, or something else entirely?",
    difficulty: "medium",
    clues: [
      { id: 1, text: "The lamp mechanism, though lately serviced, has one small cog deliberately misaligned.", belongsTo: 2 },
      { id: 12, text: "A journal entry halts mid-sentence, describing an odd glimmer far out on the water.", belongsTo: 2 },
      { id: 5, text: "Freshly turned soil near the cliff's edge suggests something was newly dragged or buried.", belongsTo: 2 }
    ]
  },
  {
    id: 3,
    title: "Case 3: The Counterfeit Canvas Calamity",
    description: "A prestigious art gallery unveils its latest acquisition, a supposed lost masterpiece, only for whispers to emerge that the painting is a brilliant forgery. The gallery director's reputation hangs in the balance.",
    difficulty: "medium",
    clues: [
      { id: 2, text: "A receipt for excessive quantities of specific, period-inconsistent artistic materials was retrieved from a wastebin.", belongsTo: 3 },
      { id: 9, text: "Microscopic analysis reveals pigment particles that fluoresce under UV light in a way uncharacteristic of the purported era.", belongsTo: 3 },
      { id: 6, text: "The official acquisition statement contains a barely perceptible alteration to the date of procurement.", belongsTo: 3 }
    ]
  },
  {
    id: 4,
    title: "Case 4: The Patent Puzzle Plunder",
    description: "On the eve of a groundbreaking invention's public demonstration, the crucial blueprints are stolen from a secure workshop. The inventor suspects a rival, but proof is elusive.",
    difficulty: "medium",
    clues: [
      { id: 11, text: "A faint, peculiar metallic odor, unidentifiable by the workshop owner, hangs in the air near the storage unit.", belongsTo: 4 },
      { id: 4, text: "The only item disturbed on an otherwise chaotic desk is a lone, overlooked cufflink of distinctive design.", belongsTo: 4 },
      { id: 7, text: "A complex locking apparatus on a secure cabinet appears undamaged, yet its contents are missing.", belongsTo: 4 }
    ]
  }
];

// Function to get the current case set (presumed to be already randomized)
export const getRandomCasePair = () => {
  return caseData;
}; 